module.exports = __webpack_public_path__ + "static/media/single-straight.e3380025.svg";